<template>
</template>
<script>
    export default {
        data() {
            return {};
        },
        methods:{
          pay(){
              var payparams = getStorage("payparams");
              var url =
                  window.location.protocol +
                  "//" +
                  window.location.hostname +
                  ":" +
                  window.location.port +
                  "/myregister";
              var payurl = payparams.free ? url : getStorage("payurl");
              payparams.code = this.$route.query.code;
              registerpayorder(payparams).then(res => {
                  if (res.status == 200) {
                      let pay = "pay";
                      setStorage("pay", pay, true);
                      if (res.data.paystate == 1) {
                          window.location.replace(payurl);
                      } else {
                          let replace = "again";
                          setStorage("replace", replace, true);
                          let shipment = res.data.shipment;
                          shipment.jumpurl = encodeURIComponent(payurl);
                          delete shipment.mweb_url;
                          let jumpurl =
                              "https://store.moveclub.cn/wechatpaynew.php?info=" +
                              encodeURIComponent(JSON.stringify(shipment));
                          window.location.replace(jumpurl);
                      }
                  } else {
                      Dialog.confirm({
                          title: "提示",
                          message: res.message
                      })
                          .then(() => {
                              // on close
                              if (payurl) {
                                  window.location.replace(payurl);
                              } else {
                                  this.$router.replace({ name: "myregister" });
                              }
                          })
                          .catch(() => {
                              goBack();
                          });
                      //处理非200

                      //
                  }
              });
          }

        },
        mounted() {

            this.$toast.loading()
            if (this.cf.isWeChat()) {

                let {code, state} = this.$route.query
                if (code && state === "authorize_wechat") {
                    this.code = code;
                    this.pay();
                    return;
                }

                this.$wechat.jsAuthorize()

            } else {
                this.$toast.fail("请在微信中打开当前页面")
                this.$router.push({name: 'index'})
            }

        }


    };
</script>
